'use strict';

import AuthModalShell from '../components/auth/AuthModalShell';

// Точка входа gj2: состояние и шаги общие (AuthModalShell),
// здесь только бренд-специфичные тексты, опции и флаги.
function Gj2AuthModal() {
    return (
        <AuthModalShell
            selectOptions={[
                { labelKey: '[Registration] Private entity', scenario: 'client', goal: 'private_person' },
                { labelKey: '[Registration] Agent or Partner', scenario: 'agency', goal: 'travel_agent' },
                { labelKey: '[Registration] Aviabroker', href: `${langPrefix}/b2b`, goal: 'broker' },
            ]}
            selectSeparatorKey="[Registration] or"
            selectLoginKey="[Auth] Log in"
            loginPrimaryKey="[Auth] Log in"
            loginSecondaryKey="[Auth] Join now"
            loginSeparatorKey={null}
            registerSecondaryKey="[Auth] Log in"
            registerSeparatorKey={null}
            requireMediaAgreement={false}
            agencyAgreementTextKey={null}
            firstNameFirst={false}
            successImageSrc={`${themeDir}/images/reg-img.jpg`}
            successDescriptionKey={null}
            successCloseKey="[Registration][Success] Lets fly!"
            codePlaceholderKey={null}
            overlayLoading={false}
        />
    );
}

const domContainer = document.querySelector('#reactAuthModal');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(Gj2AuthModal));
